export interface HistoryTableColumn {
    headerName: string;
    variant: HistoryTableColumnTypes,
}

export enum HistoryTableColumnTypes {
    USER_NAME = 'user-name',
    OPERATION = 'operation',
    COLLECTION_NAME = 'collection-name',
    UPDATED_FIELDS = 'updated-fields',
    DATE = 'date',
}